var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "master_svg0_1_545"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6D34",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99.28571581840515%",
    stopColor: "#841600",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.2132,8.7868Q42.4276,0.00125504,30.0035,0.00000214577L30,0C28.3431,0,27,1.34315,27,3C27,4.65685,28.3431,6,30,6Q39.9411,6,46.9706,13.0294Q54,20.0589,54,30Q54,38.3535,49.0366,44.651L42.0528,37.6672C45.3794,32.7589,44.8686,26.0265,40.5204,21.6784C35.5935,16.7514,27.6053,16.7514,22.6784,21.6784C17.7514,26.6053,17.7514,34.5935,22.6784,39.5205C26.7193,43.5614,32.8193,44.2881,37.6009,41.7006L44.8103,48.91Q38.4593,54,30,54Q20.0589,54,13.0294,46.9706Q6,39.9411,6,30Q6,21.4538,11.1262,15.1262L14.6594,18.6594C15.2281,19.228,16.2012,18.927,16.3494,18.1366L18.7495,5.33629C18.8738,4.67338,18.3196,4.08005,17.6498,4.15885L4.04944,5.75889C3.21965,5.85651,2.86838,6.86835,3.45917,7.45915L6.86102,10.861Q0,18.9453,0,30Q0,42.4264,8.7868,51.2132Q17.5736,60,30,60Q42.4264,60,51.2132,51.2132Q60,42.4264,60,30Q60,17.5736,51.2132,8.7868ZM36.2778,25.921C33.694,23.3372,29.5048,23.3372,26.921,25.921C24.3372,28.5048,24.3372,32.694,26.921,35.2778C29.5048,37.8616,33.694,37.8616,36.2778,35.2778C38.8616,32.694,38.8616,28.5048,36.2778,25.921Z",
    fillRule: "evenodd",
    fill: "url(#master_svg0_1_545)",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpt1);
export default __webpack_public_path__ + "static/media/opt1.ae8769cda4de2362eea1ad411b3ebe49.svg";
export { ForwardRef as ReactComponent };